import { PERSONAL_CONFIRM_IMAGE_AT } from "@/constants/constant";
import { goToErrorPage } from "@/utils/Other";

export const showSubIdentityType = (identity) => {
  // 健康保険者 or マイナンバー のときは追加書類が必要
  return identity === "04" || identity === "05";
};
export const showProofNationalityType = (nationality) => {
  // 外国籍をもっているとき
  return nationality === "02";
};
export const displayIdentityLabel = (identity) => {
  switch (identity) {
    case "01":
      return "運転免許証";
    case "02":
      return "運転経歴証明書";
    case "03":
      return "パスポート";
    case "04":
      return "健康保険証";
    case "05":
      return "マイナンバーカード（顔写真付き）";
    default:
      return "";
  }
};
export const displayFile1Label = (identity) => {
  switch (identity) {
    case "01":
      return "運転免許証（表）";
    case "02":
      return "運転経歴証明書（表）";
    case "03":
      return "パスポート(顔写真入り)";
    case "04":
      return "健康保険証（表）\n";
    case "05":
      return "マイナンバーカード（顔写真付き）";
    default:
      return "";
  }
};
export const displayFile2Label = (identity) => {
  switch (identity) {
    case "01":
      return "運転免許証（裏）";
    case "02":
      return "運転経歴証明書（裏）";
    case "03":
      return "パスポート(所持人記入欄)";
    case "04":
      return "健康保険証（裏）\n";
    case "05":
      return "";
    default:
      return "";
  }
};
export const displaySecondFile1Label = (secondIdentity) => {
  switch (secondIdentity) {
    case "01":
      return "運転免許証（表）";
    case "02":
      return "運転経歴証明書（表）";
    case "03":
      return "パスポート(顔写真入り)";
    case "04":
      return "健康保険証（表）\n";
    case "05":
      return "マイナンバーカード（顔写真付き）";
    case "06":
      return "住民票の写し（ファイル１）";
    case "07":
      return "公的書類";
    default:
      return "";
  }
};
export const displaySecondFile2Label = (secondIdentity) => {
  switch (secondIdentity) {
    case "01":
      return "運転免許証（裏）";
    case "02":
      return "運転経歴証明書（裏）";
    case "03":
      return "パスポート(所持人記入欄)";
    case "04":
      return "健康保険証（裏）\n";
    default:
      return "";
  }
};
export const displaySubIdentityLabel = (subIdentity) => {
  switch (subIdentity) {
    case "01":
      return "住民票の写し";
    case "02":
      return "公的書類";
    default:
      return "";
  }
};
export const displaySecondIdentityLabel = (secondIdentity) => {
  switch (secondIdentity) {
    case "01":
      return "運転免許証";
    case "02":
      return "運転経歴証明書";
    case "03":
      return "パスポート";
    case "04":
      return "健康保険証";
    case "05":
      return "マイナンバーカード";
    case "06":
      return "住民票の写し";
    case "07":
      return "公的書類";
    default:
      return "";
  }
};
export const displayFile3Label = (subIdentity) => {
  switch (subIdentity) {
    case "01":
      return "住民票の写し（ファイル１）";
    case "02":
      return "公的書類";
    default:
      return "";
  }
};
export const displayProofNationalityLabel = (proofNationality) => {
  switch (proofNationality) {
    case "03":
      return "在留カード";
    case "04":
      return "特別永住者証明書";
    default:
      return "";
  }
};
export const displayFile4Label = (proofNationality) => {
  switch (proofNationality) {
    case "03":
      return "在留カード（表）";
    case "04":
      return "特別永住者証明書（表）";
    default:
      return "";
  }
};
export const displayFile5Label = (proofNationality) => {
  switch (proofNationality) {
    case "03":
      return "在留カード（裏）";
    case "04":
      return "特別永住者証明書（裏）";
    default:
      return "";
  }
};
export const displayFile6Label = (subIdentity) => {
  switch (subIdentity) {
    case "01":
      return "運転免許証";
    case "02":
      return "運転経歴証明書";
    case "03":
      return "パスポート";
    case "04":
      return "健康保険証";
    case "05":
      return "マイナンバーカード";
    case "06":
      return "住民票の写し";
    case "07":
      return "公的書類";
    default:
      return "";
  }
};

export const validateIdentity = (identity, errors) => {
  try {
    let reason = [];
    if (identity) {
      if (["01", "02", "03", "04", "05"].indexOf(identity) === -1) {
        reason.push("unselect");
      }
    } else {
      reason.push("unselect");
    }
    if (reason.length > 0) {
      if (!errors) errors = {};
      errors["identity"] = reason;
    }
  } catch (e) {
    goToErrorPage(e);
  }
};
export const validateEnIdentity = (identity, errors) => {
  try {
    let reason = [];
    if (identity) {
      if (["01", "02", "03", "04", "05"].indexOf(identity) === -1) {
        reason.push("unselect");
      }
    } else {
      reason.push("unselect");
    }
    if (reason.length > 0) {
      if (!errors) errors = {};
      errors["identity_en"] = reason;
    }
  } catch (e) {
    goToErrorPage(e);
  }
};
export const validateSubIdentity = (identity, subIdentity, errors) => {
  try {
    let reason = [];
    if (identity && showSubIdentityType(identity)) {
      if (!subIdentity) {
        reason.push("unselect");
      } else {
        if (["01", "02"].indexOf(subIdentity) === -1) {
          reason.push("unselect");
        }
      }
    }
    if (reason.length > 0) {
      if (!errors) errors = {};
      errors["subIdentity"] = reason;
    }
  } catch (e) {
    goToErrorPage(e);
  }
};
export const validateSecondIdentity = (identity, secondIdentity, errors) => {
  try {
    let label = "";
    let reason = [];
    if (!secondIdentity) {
      label = "secondIdentity";
      reason.push("unselect");
    } else {
      if (
        ["01", "02", "03", "04", "05", "06", "07"].indexOf(secondIdentity) ===
        -1
      ) {
        label = "secondIdentity";
        reason.push("unselect");
      } else if (identity === secondIdentity) {
        label = "identity";
        reason.push("duplicated_identity");
      }
    }
    if (reason.length > 0) {
      if (!errors) errors = {};
      errors[label] = reason;
    }
  } catch (e) {
    goToErrorPage(e);
  }
};
export const validateNationality = (nationality, errors) => {
  try {
    let reason = [];
    if (nationality) {
      if (["01", "02"].indexOf(nationality) === -1) {
        reason.push("unselect");
      }
    } else {
      reason.push("unselect");
    }
    if (reason.length > 0) {
      if (!errors) errors = {};
      errors["nationality"] = reason;
    }
  } catch (e) {
    goToErrorPage(e);
  }
};
export const validateProofNationality = (
  nationality,
  proofNationality,
  errors
) => {
  try {
    let reason = [];
    if (nationality && showProofNationalityType(nationality)) {
      if (!proofNationality) {
        reason.push("unselect");
      } else {
        if (["03", "04"].indexOf(proofNationality) === -1) {
          reason.push("unselect");
        }
      }
    }
    if (reason.length > 0) {
      if (!errors) errors = {};
      errors["proofNationality"] = reason;
    }
  } catch (e) {
    goToErrorPage(e);
  }
};

export const getIdentityFileSbt = (identity) => {
  // (01: 運転免許書 02: 運転経歴証明書 03: パスポート 04: 健康保険被保険証書 05: マイナンバーカード 06: 在留カード 07: 特別永住者証明書 08: 住民票の写し 09: 公的書類 10: 収入証明書)
  switch (identity) {
    case "01":
      return "01";
    case "02":
      return "02";
    case "03":
      return "03";
    case "04":
      return "04";
    case "05":
      return "05";
    default:
      return "";
  }
};
export const getSubIdentityFileSbt = (subIdentity) => {
  // (01: 運転免許書 02: 運転経歴証明書 03: パスポート 04: 健康保険被保険証書 05: マイナンバーカード 06: 在留カード 07: 特別永住者証明書 08: 住民票の写し 09: 公的書類 10: 収入証明書)
  switch (subIdentity) {
    case "01":
      return "08";
    case "02":
      return "09";
    default:
      return "";
  }
};
export const getSecondIdentityFileSbt = (secondIdentity) => {
  // (01: 運転免許書 02: 運転経歴証明書 03: パスポート 04: 健康保険被保険証書 05: マイナンバーカード 06: 在留カード 07: 特別永住者証明書 08: 住民票の写し 09: 公的書類 10: 収入証明書)
  switch (secondIdentity) {
    case "01":
      return "01";
    case "02":
      return "02";
    case "03":
      return "03";
    case "04":
      return "04";
    case "05":
      return "05";
    case "06":
      return "08";
    case "07":
      return "09";
    default:
      return "";
  }
};
export const getNationalityFileSbt = (proofNationality) => {
  // (01: 運転免許書 02: 運転経歴証明書 03: パスポート 04: 健康保険被保険証書 05: マイナンバーカード 06: 在留カード 07: 特別永住者証明書 08: 住民票の写し 09: 公的書類 10: 収入証明書)
  switch (proofNationality) {
    case "03":
      return "06";
    case "04":
      return "07";
    default:
      return "";
  }
};
export const setPersonalConfirmImageAtCookie = () => {
  window.$cookies.set(
    PERSONAL_CONFIRM_IMAGE_AT,
    new Date().toJSON(),
    "15min",
    "/",
    null,
    process.env.VUE_APP_COOKIES_SECURE
  );
};

// FileUploadをimportするコンポーネントのcreated関数で実行すること
export const fileUploadCreated = () => {
  try {
    if (window.$cookies.get(PERSONAL_CONFIRM_IMAGE_AT)) {
      goToErrorPage("Image upload prohibited");
    }
  } catch (e) {
    goToErrorPage(e);
  }
};
